import ContributeForm from "../../components/contribute/ContributeNotes"


const Contributor = () => {
  return (
    <div>
        <ContributeForm/>
    </div>
  )
}

export default Contributor